module.exports = __webpack_public_path__ + "static/img/report_img_alaqtb.d68aadd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/report_img_alaqtb.png
// module id = NyAC
// module chunks = 21